import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Table } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { GET_OBJECT_HISTORY_QUERY } from '../../../graphql.js'
import { handleGraphQLErrors } from '../../../utils.js'

export const GET_OBJECT_HISTORY = gql(GET_OBJECT_HISTORY_QUERY)

export default function RoleChart(props) {
  const { schema, actionType } = props
  console.log('RoleChart rendered: ', props)

  const [spinner, setSpinner] = useState(false)
  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  function compareRoles(row) {
    const actionRoles = row.actionRoles ? row.actionRoles.split(',') : []
    const userRoles = row.userRoles ? row.userRoles.split(',') : []
    for (let role of actionRoles) {
      if (userRoles.includes(role)) {
        return { background: 'white' }
      }
    }
    return { background: 'red' }
  }

  useEffect(() => {
    async function fetchItems() {
      console.log('RoleChart fetchItems: ', {schema, actionType})
      setGraphQLErrors([])
      try {
        setSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: GET_OBJECT_HISTORY, variables: { schema: schema, actionType: actionType } })
        console.log('GET_OBJECT_HISTORY data: ', { data })
        if (data.getObjectHistory) {
          const rows = []
          for (let row of data.getObjectHistory.rows) {
            let cellStyle = compareRoles(row)
            rows.push(
              <tr key={`${row.documentTypeId}-${row.userId}`} style={{ textAlign: 'left' }}>
                <td style={cellStyle}>{row.documentTypeId}</td>
                <td style={cellStyle}>{row.documentTypeName}</td>
                <td>{row.actionRoles}</td>
                <td>{row.userId}</td>
                <td>{row.userName}</td>
                <td>{row.userRoles}</td>
              </tr>)
          }
          setItems(rows)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
    if (schema && actionType) {
      fetchItems()
    }
  }, [schema, actionType])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }
  return (
    <div style={{ marginTop: '20px' }}>
      <Table bordered style={{ padding: '.25rem', width: 'auto', margin: 'auto' }}>
        <thead>
          <tr><td colSpan={6} style={{ backgroundColor: 'lightgrey' }}>{schema} Entity Document Types</td></tr>
          <tr>
            <th>Document Type ID</th>
            <th>Document Type Name</th>
            <th>Roles</th>
            <th>User ID</th>
            <th>User Name</th>
            <th>User Roles</th>
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </Table>
    </div>
  )
}
